import { useEffect } from "react";
import { useSelector } from "react-redux";
import { notifyApiError } from "../../Apis/apiErrors";

// Shows a toast for every Core error reported by the redux-cycles layer. The fetch-based
// API functions (Apis/*.js via postJson) toast on their own, so both request layers end up
// in the same react-hot-toast <Toaster /> in the layout.
const ApiErrorToaster = () => {
  const last = useSelector(({ apiErrors }) => apiErrors && apiErrors.last);
  const seq = last ? last.seq : 0;

  useEffect(() => {
    if (last) notifyApiError(last.exception);
  }, [seq]);

  return null;
};

export default ApiErrorToaster;
